import {
  useCommitmentsWithAmountDue,
  useCommitmentsWithMissingPayments,
} from '@sola/supporter-sdk/hooks/commitments.js';

import {
  MakeAPayment,
  MakeAPaymentType,
} from '../make-a-payment/make-a-payment';

export const MakeAPaymentAlert = () => {
  const className = 'mb-comfy-xl';
  const { hasMissedPayment, missedPaymentCommitments, totalAmountMissed } =
    useCommitmentsWithMissingPayments();

  const { hasPaymentDue, commitmentsWithAmountDue, totalAmountDue } =
    useCommitmentsWithAmountDue();

  if (hasMissedPayment) {
    return (
      <MakeAPayment
        alertType={MakeAPaymentType.missingPayment}
        commitments={missedPaymentCommitments}
        amountDue={totalAmountMissed}
        className={className}
      />
    );
  }

  if (hasPaymentDue) {
    return (
      <MakeAPayment
        alertType={MakeAPaymentType.paymentDue}
        commitments={commitmentsWithAmountDue}
        amountDue={totalAmountDue}
        className={className}
      />
    );
  }

  return (
    <MakeAPayment alertType={MakeAPaymentType.payAhead} className={className} />
  );
};
